import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center">
              <img
                src="https://static.wixstatic.com/media/0184a2_a8bf1f9416934718b0472844df026b88~mv2.gif"
                alt="R&R General Contracting Logo"
                className="h-16 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <a
              href="#services"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Services
            </a>
            <a
              href="#process"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Our Process
            </a>
            <a
              href="#gallery"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Gallery
            </a>
            <a
              href="#testimonials"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Testimonials
            </a>
            <a
              href="tel:530-277-9803"
              className="flex items-center space-x-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>(530) 277-9803</span>
            </a>
            <a
              href="#contact"
              className="bg-teal-600 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Free Estimate
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-slate-700 hover:bg-slate-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <a
              href="#services"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg transition-colors cursor-pointer"
            >
              Services
            </a>
            <a
              href="#process"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg transition-colors cursor-pointer"
            >
              Our Process
            </a>
            <a
              href="#gallery"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg transition-colors cursor-pointer"
            >
              Gallery
            </a>
            <a
              href="#testimonials"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg transition-colors cursor-pointer"
            >
              Testimonials
            </a>
            <a
              href="tel:530-277-9803"
              className="block px-4 py-2 text-sm font-semibold text-teal-600 hover:bg-teal-50 rounded-lg transition-colors cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              (530) 277-9803
            </a>
            <a
              href="#contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block bg-teal-600 text-white px-4 py-2.5 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all text-center cursor-pointer"
            >
              Free Estimate
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
